// @ts-nocheck
// Auto-migrated from js/mockData.js
// ---------- 分享配置（运营管理 / 分享配置） ----------
const SHARE_CONFIGS = [
  {
    id: "cfg_pkg_001",
    config_id: "cfg_pkg_001",
    landing_page_ids: ["lp_001_new", "lp_001_return"],
    landing_page_id: "lp_001_new",
    temple_id: "temple_001",
    name: "王者征途 US iOS 专属配置",
    scope: "package",
    mode: "expert",
    package_ids: ["p_a1b2c3d4e5f6"],
    landing_rules: [
      { landing_page_id: "lp_001_new", audience: "new_user" },
      { landing_page_id: "lp_001_return", audience: "returning_user" },
    ],
    status: "released",
    channels: ["facebook", "messenger", "twitter", "discord", "reddit"],
    updated: "2026-05-15 17:32",
    owner: "张三",
    title: "Join me in epic battle!",
  },
  {
    id: "cfg_pkg_002",
    config_id: "cfg_pkg_002",
    landing_page_ids: ["lp_002_tw"],
    landing_page_id: "lp_002_tw",
    temple_id: "temple_002",
    name: "梦幻西游 TW iOS 本地化配置",
    scope: "package",
    mode: "expert",
    package_ids: ["p_q3r4s5t6u7v8"],
    landing_rules: [
      { landing_page_id: "lp_002_tw", audience: "region_tw_hk_mo" },
    ],
    status: "released",
    channels: ["line", "telegram", "facebook", "whatsapp"],
    updated: "2026-05-14 18:08",
    owner: "李四",
    title: "Invite friends to Fantasy West",
  },
  {
    id: "cfg_plan_001",
    config_id: "cfg_plan_001",
    landing_page_ids: ["lp_001_new"],
    landing_page_id: "lp_001_new",
    temple_id: "temple_001",
    name: "欧美 RPG 默认分享配置",
    scope: "package_set",
    mode: "quick",
    package_ids: ["p_a1b2c3d4e5f6", "p_g7h8i9j0k1l2", "p_m3n4o5p6q7r8", "p_s9t0u1v2w3x4", "p_y5z6a7b8c9d0"],
    landing_rules: [
      { landing_page_id: "lp_001_new", audience: "new_user" },
    ],
    status: "released",
    channels: ["facebook", "messenger", "twitter", "whatsapp", "discord"],
    updated: "2026-05-12 10:20",
    owner: "张三",
    title: "Download now and get free gems!",
  },
  {
    id: "cfg_plan_002",
    config_id: "cfg_plan_002",
    landing_page_ids: ["lp_003_event_url"],
    landing_page_id: "lp_003_event_url",
    temple_id: "temple_005",
    name: "梦幻西游 Global 通用配置",
    scope: "package_set",
    mode: "expert",
    package_ids: ["p_e1f2g3h4i5j6", "p_k7l8m9n0o1p2", "p_q3r4s5t6u7v8"],
    landing_rules: [
      { landing_page_id: "lp_003_event_url", audience: "direct_url" },
    ],
    status: "draft",
    channels: ["facebook", "telegram", "line"],
    updated: "2026-05-10 14:05",
    owner: "李四",
    title: "Start your journey with friends",
  },
  {
    id: "cfg_plan_003",
    config_id: "cfg_plan_003",
    landing_page_ids: ["lp_004_guild_recruit"],
    landing_page_id: "lp_004_guild_recruit",
    temple_id: "temple_003",
    name: "王者征途 Discord 公会招募",
    scope: "package_set",
    mode: "expert",
    package_ids: ["p_a1b2c3d4e5f6", "p_g7h8i9j0k1l2", "p_m3n4o5p6q7r8", "p_s9t0u1v2w3x4"],
    landing_rules: [
      { landing_page_id: "lp_004_guild_recruit", audience: "guild_interest" },
    ],
    status: "released",
    channels: ["discord", "facebook", "messenger"],
    updated: "2026-06-05 17:20",
    owner: "赵六",
    title: "Join my alliance and win together!",
  },
  {
    id: "cfg_plan_004",
    config_id: "cfg_plan_004",
    landing_page_ids: ["lp_008_jp_campaign"],
    landing_page_id: "lp_008_jp_campaign",
    temple_id: "temple_002",
    name: "王者征途 JP 上线预热",
    scope: "package_set",
    mode: "quick",
    package_ids: ["p_y5z6a7b8c9d0"],
    landing_rules: [
      { landing_page_id: "lp_008_jp_campaign", audience: "region_jp" },
    ],
    status: "draft",
    channels: ["twitter", "line", "facebook"],
    updated: "2026-06-05 16:45",
    owner: "李四",
    title: "Japan launch pre-registration rewards!",
  },
  {
    id: "cfg_plan_005",
    config_id: "cfg_plan_005",
    landing_page_ids: ["lp_005_first_pay"],
    landing_page_id: "lp_005_first_pay",
    temple_id: "temple_004",
    name: "梦幻西游首充礼包活动",
    scope: "package_set",
    mode: "expert",
    package_ids: ["p_e1f2g3h4i5j6", "p_k7l8m9n0o1p2", "p_q3r4s5t6u7v8"],
    landing_rules: [
      { landing_page_id: "lp_005_first_pay", audience: "new_payer" },
    ],
    status: "released",
    channels: ["facebook", "telegram", "line", "whatsapp"],
    updated: "2026-06-05 15:30",
    owner: "王五",
    title: "Claim your first top-up bonus now!",
  },
  {
    id: "cfg_plan_006",
    config_id: "cfg_plan_006",
    landing_page_ids: ["lp_009_return_reward"],
    landing_page_id: "lp_009_return_reward",
    temple_id: "temple_001",
    name: "梦幻西游 LINE 回流召回",
    scope: "package_set",
    mode: "quick",
    package_ids: ["p_q3r4s5t6u7v8"],
    landing_rules: [
      { landing_page_id: "lp_009_return_reward", audience: "returning_user" },
    ],
    status: "released",
    channels: ["line", "telegram"],
    updated: "2026-06-05 14:10",
    owner: "李四",
    title: "Come back for exclusive rewards!",
  },
  {
    id: "cfg_plan_007",
    config_id: "cfg_plan_007",
    landing_page_ids: ["lp_007_discord_party"],
    landing_page_id: "lp_007_discord_party",
    temple_id: "temple_001",
    name: "欧美 RPG Discord 组队分享",
    scope: "package_set",
    mode: "expert",
    package_ids: ["p_a1b2c3d4e5f6", "p_g7h8i9j0k1l2", "p_m3n4o5p6q7r8"],
    landing_rules: [
      { landing_page_id: "lp_007_discord_party", audience: "discord_user" },
    ],
    status: "draft",
    channels: ["discord", "reddit", "twitter"],
    updated: "2026-06-04 19:40",
    owner: "赵六",
    title: "Squad up on Discord tonight!",
  },
  {
    id: "cfg_plan_008",
    config_id: "cfg_plan_008",
    landing_page_ids: ["lp_010_ramadan_event"],
    landing_page_id: "lp_010_ramadan_event",
    temple_id: "temple_005",
    name: "东南亚 WhatsApp 拉新活动",
    scope: "package_set",
    mode: "quick",
    package_ids: ["p_s9t0u1v2w3x4", "p_k7l8m9n0o1p2"],
    landing_rules: [
      { landing_page_id: "lp_010_ramadan_event", audience: "region_sea" },
    ],
    status: "released",
    channels: ["whatsapp", "telegram", "facebook"],
    updated: "2026-06-04 16:20",
    owner: "王五",
    title: "Limited festival rewards for SEA players!",
  },
  {
    id: "cfg_plan_009",
    config_id: "cfg_plan_009",
    landing_page_ids: ["lp_006_anniversary"],
    landing_page_id: "lp_006_anniversary",
    temple_id: "temple_005",
    name: "全球周年庆社交分享",
    scope: "package_set",
    mode: "expert",
    package_ids: ["p_a1b2c3d4e5f6", "p_g7h8i9j0k1l2", "p_m3n4o5p6q7r8", "p_s9t0u1v2w3x4", "p_y5z6a7b8c9d0", "p_e1f2g3h4i5j6", "p_k7l8m9n0o1p2", "p_q3r4s5t6u7v8"],
    landing_rules: [
      { landing_page_id: "lp_006_anniversary", audience: "all_players" },
    ],
    status: "released",
    channels: ["facebook", "messenger", "twitter", "whatsapp", "telegram", "discord", "reddit"],
    updated: "2026-06-04 11:55",
    owner: "张三",
    title: "Anniversary rewards are waiting!",
  },
  {
    id: "cfg_plan_010",
    config_id: "cfg_plan_010",
    landing_page_ids: ["lp_011_halloween"],
    landing_page_id: "lp_011_halloween",
    temple_id: "temple_005",
    name: "万圣节限时礼包活动",
    scope: "package_set",
    mode: "quick",
    package_ids: ["p_a1b2c3d4e5f6", "p_g7h8i9j0k1l2", "p_e1f2g3h4i5j6", "p_k7l8m9n0o1p2"],
    landing_rules: [
      { landing_page_id: "lp_011_halloween", audience: "event_period" },
    ],
    status: "draft",
    channels: ["facebook", "twitter", "discord"],
    updated: "2026-06-03 18:35",
    owner: "赵六",
    title: "Spooky rewards are live!",
  },
  {
    id: "cfg_plan_011",
    config_id: "cfg_plan_011",
    landing_page_ids: ["lp_001_new"],
    landing_page_id: "lp_001_new",
    temple_id: "temple_001",
    name: "王者征途新手保护期邀请",
    scope: "package_set",
    mode: "quick",
    package_ids: ["p_a1b2c3d4e5f6", "p_g7h8i9j0k1l2", "p_s9t0u1v2w3x4"],
    landing_rules: [
      { landing_page_id: "lp_001_new", audience: "new_user" },
    ],
    status: "released",
    channels: ["facebook", "messenger", "whatsapp"],
    updated: "2026-06-03 13:15",
    owner: "张三",
    title: "Download now and get free gems!",
  },
  {
    id: "cfg_plan_012",
    config_id: "cfg_plan_012",
    landing_page_ids: ["lp_009_return_reward"],
    landing_page_id: "lp_009_return_reward",
    temple_id: "temple_001",
    name: "王者征途老玩家回流礼包",
    scope: "package_set",
    mode: "expert",
    package_ids: ["p_a1b2c3d4e5f6", "p_m3n4o5p6q7r8", "p_y5z6a7b8c9d0"],
    landing_rules: [
      { landing_page_id: "lp_009_return_reward", audience: "returning_user" },
    ],
    status: "released",
    channels: ["line", "facebook", "twitter"],
    updated: "2026-06-02 20:05",
    owner: "张三",
    title: "Come back for exclusive rewards!",
  },
  {
    id: "cfg_plan_013",
    config_id: "cfg_plan_013",
    landing_page_ids: ["lp_004_guild_recruit"],
    landing_page_id: "lp_004_guild_recruit",
    temple_id: "temple_003",
    name: "梦幻西游跨服组队招募",
    scope: "package_set",
    mode: "expert",
    package_ids: ["p_e1f2g3h4i5j6", "p_k7l8m9n0o1p2", "p_q3r4s5t6u7v8"],
    landing_rules: [
      { landing_page_id: "lp_004_guild_recruit", audience: "party_interest" },
    ],
    status: "draft",
    channels: ["discord", "telegram", "line"],
    updated: "2026-06-02 15:20",
    owner: "王五",
    title: "Join my alliance and win together!",
  },
  {
    id: "cfg_plan_014",
    config_id: "cfg_plan_014",
    landing_page_ids: ["lp_003_event_pay"],
    landing_page_id: "lp_003_event_pay",
    temple_id: "temple_005",
    name: "梦幻西游高价值用户福利",
    scope: "package_set",
    mode: "quick",
    package_ids: ["p_e1f2g3h4i5j6", "p_k7l8m9n0o1p2"],
    landing_rules: [
      { landing_page_id: "lp_003_event_pay", audience: "high_ltv" },
    ],
    status: "released",
    channels: ["facebook", "telegram", "reddit"],
    updated: "2026-06-01 17:10",
    owner: "李四",
    title: "Exclusive rewards for top players!",
  },
  {
    id: "cfg_plan_015",
    config_id: "cfg_plan_015",
    landing_page_ids: ["lp_006_anniversary"],
    landing_page_id: "lp_006_anniversary",
    temple_id: "temple_005",
    name: "欧美 RPG Twitter 话题活动",
    scope: "package_set",
    mode: "expert",
    package_ids: ["p_a1b2c3d4e5f6", "p_g7h8i9j0k1l2", "p_m3n4o5p6q7r8", "p_y5z6a7b8c9d0"],
    landing_rules: [
      { landing_page_id: "lp_006_anniversary", audience: "social_topic" },
    ],
    status: "released",
    channels: ["twitter", "facebook", "reddit"],
    updated: "2026-05-31 12:30",
    owner: "赵六",
    title: "Anniversary rewards are waiting!",
  },
  {
    id: "cfg_plan_016",
    config_id: "cfg_plan_016",
    landing_page_ids: ["lp_007_discord_party"],
    landing_page_id: "lp_007_discord_party",
    temple_id: "temple_001",
    name: "Telegram 社群裂变活动",
    scope: "package_set",
    mode: "quick",
    package_ids: ["p_s9t0u1v2w3x4", "p_e1f2g3h4i5j6", "p_k7l8m9n0o1p2", "p_q3r4s5t6u7v8"],
    landing_rules: [
      { landing_page_id: "lp_007_discord_party", audience: "community_user" },
    ],
    status: "draft",
    channels: ["telegram", "discord", "whatsapp"],
    updated: "2026-05-30 18:00",
    owner: "王五",
    title: "Squad up on Discord tonight!",
  },
  {
    id: "cfg_plan_017",
    config_id: "cfg_plan_017",
    landing_page_ids: ["lp_010_ramadan_event"],
    landing_page_id: "lp_010_ramadan_event",
    temple_id: "temple_005",
    name: "新加坡本地化拉新",
    scope: "package_set",
    mode: "expert",
    package_ids: ["p_s9t0u1v2w3x4"],
    landing_rules: [
      { landing_page_id: "lp_010_ramadan_event", audience: "region_sg" },
    ],
    status: "released",
    channels: ["whatsapp", "facebook", "telegram"],
    updated: "2026-05-29 16:40",
    owner: "王五",
    title: "Limited festival rewards for SEA players!",
  },
  {
    id: "cfg_plan_018",
    config_id: "cfg_plan_018",
    landing_page_ids: ["lp_009_return_reward"],
    landing_page_id: "lp_009_return_reward",
    temple_id: "temple_001",
    name: "版本更新召回分享",
    scope: "package_set",
    mode: "quick",
    package_ids: ["p_a1b2c3d4e5f6", "p_g7h8i9j0k1l2", "p_e1f2g3h4i5j6", "p_k7l8m9n0o1p2"],
    landing_rules: [
      { landing_page_id: "lp_009_return_reward", audience: "returning_user" },
    ],
    status: "draft",
    channels: ["facebook", "messenger", "telegram"],
    updated: "2026-05-28 10:25",
    owner: "张三",
    title: "Come back for exclusive rewards!",
  },
];

const SHARE_SCENARIOS = [
  { id: "scn_invite", name: "好友邀请", desc: "好友召回、组队、邀请入坑等常规分享场景" },
  { id: "scn_recall", name: "流失召回", desc: "面向老玩家 / 流失玩家的回流激励场景" },
  { id: "scn_event", name: "活动分享", desc: "节日活动、限时礼包、首充福利等活动场景" },
];

export { SHARE_CONFIGS, SHARE_SCENARIOS };
